import { saveAs } from "file-saver";

import { PDF_TYPE, PNG_TYPE, convertBase64ToBlob } from "./utils";

export const downloadBase64AsPDF = (base64: string, name: string, errorCallback: () => void): void => {
  try {
    const type = PDF_TYPE;
    const blob = convertBase64ToBlob(base64);
    const file = new File([blob], `${name}.pdf`, { type });
    saveAs(file);
  } catch (_) {
    errorCallback();
  }
};

export const downloadBase64AsPNG = (base64: string, name: string, errorCallback: () => void): void => {
  try {
    const type = PNG_TYPE;
    const blob = convertBase64ToBlob(base64);
    const file = new File([blob], `${name}.png`, { type });
    saveAs(file);
  } catch (_) {
    errorCallback();
  }
};
